app.service('pageConfig', function ($global, broker) {
	let defaults = {
		basket: {
			quantity: 0,
			items: []
		},
		order: {},
		operator: {},
		precart: {},
		emailsRules: {}
	};

	let config = $.extend(true, [], defaults);

	function initData(page, params) {
		if (defaults[page]) {
			config[page] = $.extend({}, defaults[page], params);
		}
		broker.trigger('PAGE_CONFIG_INIT');
	}

	function setData({ page, data }) {
		Object.keys(data).forEach(key => {
			config[page][key] = data[key];
		});
	}

	function getData(page) {
		if (config[page]) {
			return config[page];
		}
	}
	$global('pageConfig', initData);

	return {
		getData,
		setData
	};
});
